import { render, staticRenderFns } from "./AcademicReport.vue?vue&type=template&id=7c4632a2&scoped=true"
import script from "./AcademicReport.vue?vue&type=script&lang=js"
export * from "./AcademicReport.vue?vue&type=script&lang=js"
import style0 from "./AcademicReport.vue?vue&type=style&index=0&id=7c4632a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4632a2",
  null
  
)

export default component.exports